@let desktop = isDesktop();

@if (desktop) {
  <ng-container *ngTemplateOutlet="dialogTemplateRef"></ng-container>
} @else {
  <div
    class="mobile-container"
    iwSwipeGesture
    [class.full-width]="data.fullWidth"
    [class.full-screen]="data.fullScreen"
    (swipeDown)="onSwipeDown()"
    [allowedDirections]="[swipeDirectionEnum.Down]"
  >
    <ng-container *ngTemplateOutlet="dialogTemplateRef"></ng-container>
  </div>
}

<ng-template #dialogTemplateRef>
  <div class="dialog">
    @if (title) {
      <header class="dialog-header" data-testid="base_dialog_header">
        <h4 class="dialog-header-text" data-testid="base_dialog_title">
          {{ title }}
          @if (data.subtitle) {
            <span class="dialog-header-subtitle">{{
              data.subtitle || "dialog.header.subtitle" | translate
            }}</span>
          }
        </h4>

        @if (data.message) {
          <p class="dialog-header-message">{{ data.message | translate }}</p>
        }
      </header>
    }

    <div
      cdkScrollable
      class="dialog-body"
      [class.no-title]="!title"
      data-testid="base_dialog_body"
    >
      <ng-container *ngComponentOutlet="component" />
    </div>
  </div>

  <iw-button
    class="dialog-close"
    uiType="custom"
    [size]="desktop ? 'm' : 's'"
    data-testid="base_dialog_close"
    [onlyIcon]="true"
    (clicked)="dialogRef.close()"
  >
    <fu-icon iconName="close" [size]="desktop ? 24 : 16" />
  </iw-button>
</ng-template>
